export var BulkAction;
(function (BulkAction) {
    BulkAction["Publish"] = "bulk-publish";
    BulkAction["Unpublish"] = "bulk-unpublish";
    BulkAction["Delete"] = "bulk-delete";
})(BulkAction || (BulkAction = {}));
